import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changelebels'
})
export class ChangelebelsPipe implements PipeTransform {

  transform(val: any): any {
    if (!val || !val.label) {
      return null;
    }

    let deck_length = val.label;
    deck_length = deck_length.replace(/_/g, ' ');
    deck_length = deck_length?.toLowerCase().replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });

    return deck_length;
  }

}
